<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Terminal">
                                        <a-select v-model="inputTerminal" showSearch placeholder="All Terminals" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Cashier">
                                        <a-select v-model="inputCashier" showSearch placeholder="All Cashiers" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in cashierOptions" :key="option.id" :value="option.id">{{option.first_name}} {{option.last_name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')" type="xlsx" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { getReportDescription } from '../../utilities';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                inputTerminal: 0,
                inputCashier: 0,
                site_type: "ho",
                siteOptions: [],
                terminalOptions: [],
                cashierOptions: [],
                birSalesReports: [],
                JsonData: [],
                reportDescription: ''
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
            component_x.terminalOptions = terminals;
            component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
            component_x.sort(component_x.terminalOptions);

            let users = await HTTPRequest.getRequest(component_x.endPoint + 'users/get_valid_cashiers', null);
            component_x.cashierOptions = users;
            component_x.cashierOptions.push({id: 0, first_name: ' All Users', last_name: ''})
            component_x.cashierOptions.sort(function (a, b) {
                let aname = a.first_name + ' ' + a.last_name
                let bname = b.first_name + ' ' + b.last_name
                return aname.localeCompare(bname);
            });
            this.reportDescription = await getReportDescription(this.currentProfile)

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let discount_type = ['LSP','LSA','NWP','OVA'];

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'price_change_by_line?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&terminal_id=' + this.inputTerminal + '&user_id=' + this.inputCashier + '&discount_type=' + discount_type, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }
                let reportLogo = document.getElementById('reportLogo');

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b3' });

                    for(var x=0; x < siteSpecific.length; x++){
                        doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let design_y = 20
                        
                        doc.text(15,design_y,`Price Change by Line Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                        if(x > 0){
                            //add new page
                            doc.addPage();
                        }

                        design_y = design_y + 10;
                        doc.text(15,design_y,"Store Name: " + siteSpecific[x].report_details[0].site_code + " " + siteSpecific[x].report_details[0].site_name)

                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''

                        let detailColStyles = {
                            0: {cellWidth: 40},
                            1: {cellWidth: 40},
                            2: {cellWidth: 40},
                            3: {cellWidth: 30},
                            4: {cellWidth: 45},
                            5: {cellWidth: 60},
                            6: {cellWidth: 30},
                            7: {cellWidth: 40},
                            8: {cellWidth: 30},
                            9: {cellWidth: 30},
                            10: {cellWidth: 30},
                            11: {cellWidth: 30},
                            12: {cellWidth: 30}
                        } 
                        
                        let header = [
                            {content: 'Date Time', styles: {halign: 'center'}},
                            {content: 'Terminal\n& Receipt #', styles: {halign: 'center'}},
                            {content: 'Cashier', styles: {halign: 'center'}},
                            {content: 'Supervisor Code', styles: {halign: 'center'}},
                            {content: 'SKU & Barcode', styles: {halign: 'center'}},
                            {content: 'Description', styles: {halign: 'center'}},
                            {content: 'Discount\nType', styles: {halign: 'center'}},
                            {content: 'Reason', styles: {halign: 'center'}},
                            {content: 'Quantity', styles: {halign: 'center'}},
                            {content: 'Original\nPrice', styles: {halign: 'center'}},
                            {content: 'Price', styles: {halign: 'center'}},
                            {content: 'Discount\nPercent', styles: {halign: 'center'}},
                            {content: 'Discount\nAmount', styles: {halign: 'center'}}
                        ]

                        if(this.birSalesReports.length > 0){
                            let reportData = []
                            let grouper = 'start'
                            
                            let sub_qty = 0
                            let sub_original = 0
                            let sub_price = 0
                            let sub_percent = 0
                            let sub_discount = 0

                            let total_qty = 0
                            let total_original = 0
                            let total_price = 0
                            let total_percent = 0
                            let total_discount = 0
                            

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                
                                let grouper_name = moment(reportLine.business_date).format('MM/DD/YYYY hh:mm:ss A')
                                if(grouper == 'start'){
                                    let detail_header = [{content: `Business Date: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.business_date){
                                        let detail_header = [{content: `Business Date: ${grouper_name}`, colSpan: 2, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }

                                grouper = reportLine.business_date

                                //body
                                let detail = [
                                    {content: moment(reportLine.business_date).format('MM/DD/YYYY hh:mm:ss A'), styles: {halign: 'left'}},
                                    {content: reportLine.terminal_name, styles: {halign: 'left'}},
                                    {content: reportLine.cashier_name, styles: {halign: 'left'}},
                                    {content: (reportLine.supervisor_code == null) ? '' : reportLine.supervisor_code, styles: {halign: 'left'}},
                                    {content: reportLine.barcode, styles: {halign: 'left'}},
                                    {content: reportLine.product_name, styles: {halign: 'left'}},
                                    {content: reportLine.discount_type, styles: {halign: 'left'}},
                                    {content: (reportLine.discount_reason == null) ? '' : reportLine.discount_reason, styles: {halign: 'left'}},
                                    {content: this.convertToCurrency(Number(reportLine.quantity)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.original_price)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.price)), styles: {halign: 'right'}},
                                    {content: reportLine.discount_text + '%', styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.discount_amount_p)), styles: {halign: 'right'}}
                                ]
                                
                                    sub_qty += Number(reportLine.quantity)
                                    total_qty += Number(reportLine.quantity)
                                    sub_original += Number(reportLine.original_price)
                                    total_original += Number(reportLine.original_price)
                                    sub_price += Number(reportLine.price)
                                    total_price += Number(reportLine.price)
                                    sub_percent += Number(reportLine.discount_text)
                                    total_percent += Number(reportLine.discount_text)
                                    sub_discount += Number(reportLine.discount_amount_p)
                                    total_discount += Number(reportLine.discount_amount_p)
                                
                                reportData.push(detail)
                                
                                let total_detail = []
                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    
                                    sub_detail = ['', '', '', '', '', '', '', '',
                                        {content: this.convertToCurrency(sub_qty), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(sub_original), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(sub_price), styles: {fontStyle: 'bold'}}, '',
                                        // {content: this.convertToCurrency(sub_percent), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(sub_discount), styles: {fontStyle: 'bold'}}
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(sub_detail)

    
                                    total_detail = ['', '', '', '', '', '', '',
                                        'Total :',
                                        this.convertToCurrency(total_qty),
                                        this.convertToCurrency(total_original),
                                        this.convertToCurrency(total_price), '',
                                        // this.convertToCurrency(total_percent),
                                        this.convertToCurrency(total_discount)
                                    ]

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(total_detail)

                                    //create table
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [header],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.business_date
                                    next_grouper = this.birSalesReports[i+1].business_date

                                    if(current_grouper != next_grouper){
                                        sub_detail = ['', '', '', '', '', '', '', '',
                                        {content: this.convertToCurrency(sub_qty), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(sub_original), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(sub_price), styles: {fontStyle: 'bold'}}, '',
                                        // {content: this.convertToCurrency(sub_percent), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(sub_discount), styles: {fontStyle: 'bold'}}
                                        ]
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(sub_detail)

        
                                        total_detail = ['', '', '', '', '', '', '',
                                            'Total :',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_original),
                                            this.convertToCurrency(total_price),
                                            this.convertToCurrency(total_percent),
                                            this.convertToCurrency(total_discount)
                                        ]

                                        sub_qty = 0
                                        sub_original = 0
                                        sub_price = 0
                                        sub_percent = 0
                                        sub_discount = 0 
                                    }   
                                }
                            }
                        }
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    for(let i = 0; i < pageCount; i++) { 
                        doc.setPage(i);
                        doc.text(490, 560,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                    }
                    //doc.save(`Price_Change_By_Line_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let discount_type = ['LSP','LSA','NWP','OVA'];

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'price_change_by_line?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&terminal_id=' + this.inputTerminal + '&user_id=' + this.inputCashier + '&discount_type=' + discount_type, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let headers = [];
                    let site_specific = [];
                    for(var x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''

                        headers = ['Date Time','Terminal & Receipt #','Cashier','Supervisor Code','SKU & Barcode','Description','Discount Type','Reason','Quantity','Original Price','Price','Discount Percent','Discount Amount']
                        let reportData = []
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'
                            
                            let sub_qty = 0
                            let sub_original = 0
                            let sub_price = 0
                            let sub_percent = 0
                            let sub_discount = 0

                            let total_qty = 0
                            let total_original = 0
                            let total_price = 0
                            let total_percent = 0
                            let total_discount = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                
                                let grouper_name = moment(reportLine.business_date).format('MM/DD/YYYY hh:mm:ss A')
                                if(grouper == 'start'){
                                    let detail_header = [`Business Date: ${grouper_name}`];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.business_date){
                                        let detail_header = [`Business Date: ${grouper_name}`];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }

                                grouper = reportLine.business_date

                                //body
                                let detail = [
                                              moment(reportLine.business_date).format('MM/DD/YYYY hh:mm:ss A'),
                                              reportLine.terminal_name,
                                              reportLine.cashier_name,
                                              reportLine.supervisor_code,
                                              reportLine.barcode,
                                              reportLine.product_name,
                                              reportLine.discount_type,
                                              reportLine.discount_reason,
                                              this.convertToCurrency(Number(reportLine.quantity)),
                                              this.convertToCurrency(Number(reportLine.original_price)),
                                              this.convertToCurrency(Number(reportLine.price)),
                                              Number(reportLine.discount_text) + '%',
                                              this.convertToCurrency(Number(reportLine.discount_amount_p))
                                              ]
                                reportData.push(detail)

                                sub_qty += Number(reportLine.quantity)
                                total_qty += Number(reportLine.quantity)
                                sub_original += Number(reportLine.original_price)
                                total_original += Number(reportLine.original_price)
                                sub_price += Number(reportLine.price)
                                total_price += Number(reportLine.price)
                                sub_percent += Number(reportLine.discount_text)
                                total_percent += Number(reportLine.discount_text)
                                sub_discount += Number(reportLine.discount_amount_p)
                                total_discount += Number(reportLine.discount_amount_p)
                
                                let total_detail = []
                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){

                                    sub_detail = ['', '', '', '', '', '', '', '',
                                                this.convertToCurrency(sub_qty),
                                                this.convertToCurrency(sub_original),
                                                this.convertToCurrency(sub_price), '',
                                                //this.convertToCurrency(sub_percent),
                                                this.convertToCurrency(sub_discount)
                                    ]
                                    // reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(sub_detail)

    
                                    total_detail = ['', '', '', '', '', '', '',
                                        'Total :',
                                        this.convertToCurrency(total_qty),
                                        this.convertToCurrency(total_original),
                                        this.convertToCurrency(total_price), '',
                                        //this.convertToCurrency(total_percent),
                                        this.convertToCurrency(total_discount)
                                    ]

                                    reportData.push(total_detail)
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.business_date
                                    next_grouper = this.birSalesReports[i+1].business_date

                                    if(current_grouper != next_grouper){
                                        
                                        sub_detail = ['', '', '', '', '', '', '', '',
                                                this.convertToCurrency(sub_qty),
                                                this.convertToCurrency(sub_original),
                                                this.convertToCurrency(sub_price), '',
                                                //this.convertToCurrency(sub_percent),
                                                this.convertToCurrency(sub_discount)
                                        ]
                                        reportData.push(sub_detail)

                                        sub_qty = 0
                                        sub_original = 0
                                        sub_price = 0
                                        sub_percent = 0
                                        sub_discount = 0
                                    }   
                                }
                            }
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>